import React from "react";
import "./Synonyms.css";

export default function Synonyms(props) {
  if (props.synonyms) {
    return (
      <div className="Synonyms pt-4">
        <h3>synonyms</h3>
        {props.synonyms.map(function (synonym, index) {
          return (
            <div key={index}>
              <p> {synonym} </p>
            </div>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}
